import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const aboutContent = {
  eyebrow: 'DETRÁS DEL MEGAPACK',
  title: 'Hecho por profesionales, para profesionales',
  paragraphs: ['En Habitandomicuerpo creamos material clínico pensado para acompañar el neurodesarrollo infantil con rigor, sensibilidad y mirada interdisciplinaria.', 'Sabemos lo que es llegar a la consulta sin tiempo para preparar fichas, registros o actividades visuales. Por eso diseñamos este MegaPack: para que tu energía vaya donde realmente importa, en el vínculo con cada niño y su familia.'],
  signatureName: 'Equipo Habitandomicuerpo',
  signatureRole: 'Profesionales en estimulación y neurodesarrollo infantil',
  imageUrl: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1000&auto=format&fit=crop',
  imageAlt: 'Equipo Habitandomicuerpo'
};
export function About() {
  return <section className="py-24 px-4 bg-[#0f0f0f]" data-id="element-18">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative order-2 md:order-1" data-id="element-20">
          <div className="absolute inset-0 bg-brand-accent/20 rounded-2xl blur-2xl -z-10" data-id="element-21" />
          <img src={aboutContent.imageUrl} alt={aboutContent.imageAlt} className="rounded-2xl border border-brand-cardBorder shadow-xl w-full object-cover aspect-[4/5]" data-id="element-22" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="order-1 md:order-2" data-id="element-23">
          <span className="text-sm font-medium tracking-wider uppercase text-brand-accent mb-4 block" data-id="element-24">
            {aboutContent.eyebrow}
          </span>
          <h2 className="text-3xl md:text-5xl font-serif mb-8 text-brand-light leading-tight" data-id="element-25">
            {aboutContent.title}
          </h2>
          <Quote className="w-8 h-8 text-brand-accent/40 mb-4" data-id="element-26" />
          <div className="space-y-4 mb-8" data-id="element-27">
            {aboutContent.paragraphs.map((p, i) => <p key={i} className="text-lg text-brand-light/80 font-sans leading-relaxed" data-id="element-28">
                {p}
              </p>)}
          </div>
          <div className="border-t border-brand-cardBorder pt-6" data-id="element-29">
            <p className="font-serif text-xl text-brand-light" data-id="element-30">
              {aboutContent.signatureName}
            </p>
            <p className="text-sm text-brand-light/60 font-sans" data-id="element-31">
              {aboutContent.signatureRole}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}